import { PrizeWinnerData, PrizeWinner } from '@/components/game/_domain/server/prize-winner/prize-winner-data';
import { IXmlNode } from '@/app-modules/server-communications';
import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';
import { safeCast } from '@/helper';
import { getPrizeTypeNameForLevel } from '@/components/game/implementations/uk/the-machine/_domain/models/prize-type';

class TheMachinePrizeWinner extends PrizeWinnerData {
  constructor(node: IXmlNode) {
    super(node);
  }

  protected getStages(node: IXmlNode): DefaultStageElement[] {
    return [];
  }

  protected getWinners(node: IXmlNode): PrizeWinner[] {
    const winnerNodes = node.childNodes.winner;
    const winnerList: PrizeWinner[] = [];

    this.jackpot = safeCast(node.attributes.jackpot, false);

    winnerNodes.forEach((winnerNode) => {
      const prizeWinner = new PrizeWinner(winnerNode);
      prizeWinner.prizeName = getPrizeTypeNameForLevel(prizeWinner.level);
      prizeWinner.stage = prizeWinner.level;
      winnerList.push(prizeWinner);
    });

    return winnerList;
  }
}

export { TheMachinePrizeWinner };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/the-machine/_domain/models/prize-winner.ts